import {
  type CreateShipmentOrderImportJobDto,
  apiClient,
  type ShipmentOrderImportJobExEntity
} from '@/libs/api'

export type CreateShipmentOrderImportJobRequest = {
  tenantKey: string
  dto: CreateShipmentOrderImportJobDto
}

export const createShipmentOrderImportJob = async ({
  tenantKey,
  dto
}: CreateShipmentOrderImportJobRequest): Promise<ShipmentOrderImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_jobs.$post({
      body: dto
    })
  return data
}
